import * as React from 'react';
import { Translate } from '../../Translate';
import { ReportMessage } from '../ReportMessage';

export const NotEnoughDataMessage: React.FC = () => (
    <ReportMessage>
        <Translate keyId="REPORT.NOT_ENOUGH_DATA" />
    </ReportMessage>
);
NotEnoughDataMessage.displayName = 'NotEnoughDataMessage';
